import { useCallback } from 'react'

import { FileUploader } from '@circlefin/components'

import { useL3Onboarding } from '../../../../hooks/l3-onboarding'

import type { FileUploaderItemProps } from '@circlefin/components/lib/FileUploader/FileUploader.Item/FileUploader.Item'

interface ItemProps extends Omit<FileUploaderItemProps, 'onActionClick'> {
  /**
   * Field name.
   */
  name: string
  /**
   * Document Id.
   */
  documentId: string
  /**
   * Hide delete button.
   */
  hideDelete?: boolean
  /**
   * Handle remove file.
   */
  onRemoveFile?: (documentId: string) => void
}

export const MultipleFileUploaderItem: React.FC<ItemProps> = ({
  name,
  documentId,
  onRemoveFile,
  disabled = false,
  hideDelete = false,
  ...props
}) => {
  const [{ shouldDisableForm, onboardingId }] = useL3Onboarding()

  /**
   * Delete file.
   */
  const handleDeleteFile = useCallback(() => {
    // The file will be unlinked when the form is saved.
    onRemoveFile?.(documentId)
  }, [documentId, onRemoveFile])

  /**
   * Handle file download.
   */
  const handleDownloadFile = useCallback(() => {
    window.location.assign(
      `/api/download/onboarding/${onboardingId}/documents/${documentId}`,
    )
  }, [onboardingId, documentId])

  return (
    <FileUploader.Item
      data-testid="file-uploader-item"
      {...props}
      disabled={shouldDisableForm || disabled}
      onActionClick={hideDelete ? undefined : handleDeleteFile}
      onFileNameClick={handleDownloadFile}
      noCancel
    />
  )
}
